export default function getGridDimensionsFromTiles(positions2D: Record<string, number>[]) {
  // gets min and max values for grid's dimension
  let minX = Number.MAX_SAFE_INTEGER
  let minY = Number.MAX_SAFE_INTEGER
  let maxX = Number.MIN_SAFE_INTEGER
  let maxY = Number.MIN_SAFE_INTEGER

  positions2D.forEach(p => {
    minX = p.x < minX ? p.x : minX
    minY = p.y < minY ? p.y : minY
    maxX = p.x > maxX ? p.x : maxX
    maxY = p.y > maxY ? p.y : maxY
  })
  return {
    minX,
    minY,
    maxX,
    maxY,
  }
}
